// extracted by mini-css-extract-plugin
export var buttonWrapper = "LinkButton-module--buttonWrapper--80c5d";
export var underline = "LinkButton-module--underline--0a012";
export var underlinedefault = "LinkButton-module--underlinedefault--3615b";
export var underlinelarge = "LinkButton-module--underlinelarge--a423a";
export var underlinemini = "LinkButton-module--underlinemini--6e156";
export var underlinesmall = "LinkButton-module--underlinesmall--cac5e";